export const SET_IS_API_LOADING = 'setIsApiLoading';

export const mutations = {
    [SET_IS_API_LOADING](state, isLoading) {
        state.isApiLoading = isLoading;
    }
}
